import RfidCardListContainer from '../../../../Componant/Application/Ecommerce/master/RfidCardListContainer'

const RfidCardList = () => {
  return (
    <div className='page-body'>
      <RfidCardListContainer />
    </div>
  )
}

export default RfidCardList